import { Button, Modal, Stack, Text } from '@mantine/core';

import { ModalTitle } from 'components/modals/ModalTitle';
import { SubscriptionUpdateCommonProps } from 'components/subscriptions/types';

import { useSubscriptionReleaseSchedule } from '../useSubscriptionReleaseSchedule';

export const Resubscribe = (subscriptionProps: SubscriptionUpdateCommonProps) => {
    const { team } = subscriptionProps;

    const { submitSubscriptionReleaseSchedule, loading } = useSubscriptionReleaseSchedule(subscriptionProps);

    return (
        <>
            <Modal.Header>
                <Modal.Title>
                    <ModalTitle title="Resubscribe" />
                </Modal.Title>
                <Modal.CloseButton />
            </Modal.Header>
            <Modal.Body>
                <Stack gap="lg">
                    <Text>
                        By continuing, you will re-subscribe all subscriptions for the <strong>{team.name}</strong>{' '}
                        team.
                        <br />
                        <br />
                        This will cancel your pending cancellation request, and all subscriptions will remain active
                        with uninterrupted access to current features.
                    </Text>
                    <Button
                        variant="filled"
                        size="md"
                        loading={loading}
                        type="submit"
                        onClick={submitSubscriptionReleaseSchedule}
                    >
                        Resubscribe
                    </Button>
                </Stack>
            </Modal.Body>
        </>
    );
};
